import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { PreviewService } from 'core/api/services/preview';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';
import { BookingOrigin, Price, PriceStatus } from '@utriper/core';
import { Chip, PreviewExperience } from '@utriper/core-ui';
import { RequestQuote } from '@mui/icons-material';
import { Button, Grid2, Typography } from '@mui/material';

const PriceGroupCard = ({ id, name, status, type, experienceId, bookingOrigins = [] }) => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const { getStatusColor } = usePriceGroupTab();
    const translate = (value) => t(`price_group_tab_id.card.${value}`);

    const statusColor = getStatusColor(status);
    const statusLabel = PriceStatus.getTranslatedName(PriceStatus.status, status, i18n.language);
    const origins = bookingOrigins?.map((bkOrigin) => ({
        id: bkOrigin,
        name: BookingOrigin.getTranslatedName(BookingOrigin.types, bkOrigin, i18n.language),
    }));

    const handleClick = () => {
        history.push(`/price-group/${id}`);
    };

    return (
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <Button sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '16px', p: '16px', backgroundColor: 'white', border: 'solid 1px #13131340', borderRadius: '8px', boxShadow: 'var(--shadow-card)', boxSizing: 'border-box', width: '100%', textTransform: 'none', overflow: 'hidden' }} onClick={handleClick}>
                <Grid2 container width="100%" justifyContent="space-between" alignItems="flex-start">
                    <RequestQuote sx={{ fontSize: '32px', color: 'var(--color-utriper-blue)' }} />
                    <Chip label={statusLabel} sx={{ background: `${statusColor}40`, color: `${statusColor}`, padding: '8px 4px', borderRadius: '4px' }} />
                </Grid2>
                <Typography fontSize={20} fontWeight={700} sx={{ color: '#131313', maxWidth: '100%' }} noWrap>
                    {name}
                </Typography>

                {/* Experience */}
                <Grid2 container width="100%" justifyContent="flex-start" alignItems="center" gap="8px">
                    <Typography fontSize={14} fontWeight={600} sx={{ color: '#131313bf' }}>
                        {translate('experience')}
                    </Typography>
                    <PreviewExperience id={experienceId} label="name" previewService={PreviewService} />
                </Grid2>

                {/* Price Type */}
                <Grid2 container width="100%" justifyContent="flex-start" alignItems="center" gap="8px">
                    <Typography fontSize={14} fontWeight={600} sx={{ color: '#131313bf' }}>
                        {translate('type')}
                    </Typography>
                    <Typography fontSize={14} fontWeight={500} sx={{ color: '#131313bf' }}>
                        {Price.getTranslatedName(Price.types, type, i18n.language)}
                    </Typography>
                </Grid2>

                {/* Booking Origins */}
                {origins?.length > 0 && (
                    <Grid2 container width="100%" justifyContent="flex-start" alignItems="center" gap="8px">
                        <Typography fontSize={14} fontWeight={600} sx={{ color: '#131313bf' }}>
                            {translate('origins')}
                        </Typography>
                        {origins.map((origin) => (
                            <Chip key={origin?.id} label={origin?.name} sx={{ background: '#131313', color: '#fff' }} />
                        ))}
                    </Grid2>
                )}
            </Button>
        </Grid2>
    );
};

export default PriceGroupCard;
